import styled from "styled-components";

export const Wrapper = styled.div`
  z-index: 2;
  overflow: hidden;
  position: fixed;
  top: 3rem;
  right: 3rem;
  width: 32.2rem;
  
  color: ${({ theme }) => theme.textColor.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: none;
  }
`;

export const Content = styled.div`
  padding: 30px 19px 19px;
  position: relative;
  background-color: #2F2F2F;
  margin-top: 182px;

  h3 {
    font-weight: bold;
    font-size: 15px;
    line-height: 22px;
    color: #E5E5E5;
    margin-bottom: 11px;
  }
`;

export const Indicators = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);

  .half-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 17px 20px;

    &.border-right {
      border-right: 1px solid rgba(255, 255, 255, 0.5);
    }

    p {
      display: flex;
      align-items: center;
      font-family: Open Sans;
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      color: #E5E5E5;
      margin: 0;
    }

    span {
      display: inline-flex;
      align-items: center;
      margin-left: 5px;
      font-family: Open Sans;
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      color: #E5E5E5;
    }
  }
`;

export const Footer = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin-left: 22px;
    font-family: Open Sans;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #E5E5E5;
  }
`;

export const FormItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  p {
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: #C4C4C4;
  }

  .MuiSelect-root {
    height: 36px;
    background-color: #232323 !important;
    color: #C4C4C4;
    padding: 8px 12px;
    font-family: Open Sans;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    min-width: 110px;
  }

  .MuiSelect-icon {
    vertical-align: middle;
    color: #C4C4C4;
  }

  .MuiSelect-select, .MuiSelect-filled {
    padding: 0px;
    padding-right: 30px;
    margin: 0px;
    vertical-align: middle;
  }

  .MuiFilledInput-underline:before {
    border-bottom: none;
  }

  .MuiFilledInput-underline:after {
    border-bottom: none;
  }

  .MuiFilledInput-underline:hover:before {
    border-bottom: none;
  }

  .MuiFilledInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;